export function defaultLocaleRequired($el, required) {
  if (!$el.val()) {
    return true;
  }
  const tabsContentElement = $el.closest(".tabs-content")[0];
  const localizedElements = [...tabsContentElement.querySelectorAll("input,textarea")];
  const defaultLocaleFormElement = localizedElements.find((element) => element.id.endsWith(`_${Decidim.config.config.default_locale}`));
  return !!defaultLocaleFormElement.value;
}
Foundation.Abide.defaults.validators["default_locale_required"] = defaultLocaleRequired;
